import React from 'react';
import classNames from 'classnames';
import { Component, Props } from './types';
import './Error.scss';

const Error: Component = ({
  children,
  className,
}: Props): React.ReactElement => {
  const rootClassName = classNames(
    'Error',
    className,
  );

  return (
    <div className={rootClassName}>
      {children}
    </div>
  );
};

export {
  Error,
};
